<template>
  <div class="s-intro-big fixed" v-if="detailOne">
    <span class="close " @click="()=>{$emit('hide')}"><i class="iconfont icon-close-line"></i></span>
    <div class="intro-pics">
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(pic,i) in detailOne.imgList" :key="i">
          <!-- <van-image class="bg" :src="showpath+pic" fit="cover"></van-image> -->
          <van-image :src="showpath+pic" fit="cover"></van-image>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/{{detailOne.imgList.length}}</div>
        </template>
      </van-swipe>

    </div>
    <div class="intro-detail">
      <span class="title">{{detailOne.name}}</span>
      <div class="cate">
        <div class="cate-item" v-for="(tag,i) in detailOne.tags" :key="i">{{tag}}</div>
        <!-- <div class="cate-item">种子资源</div> -->
      </div>
      <!-- <div class="brief srollbox" v-html="detailOne.introduce"></div> -->
      <div class="brief srollbox" v-if="detailOne.introduce" :style="{'height':maxTxt}">
        <fold-txt-2  :content="'简介：'+detailOne.introduce" :max.sync="maxTxt" ></fold-txt-2>
      </div>
      <s-audioprogress v-if="playInfo" :playInfo="playInfo"></s-audioprogress>
      <div class="audio-list" v-if="mp3list.length>1">
        <div class="audio-list-item" :class="{'active':item.media_path==playInfo.media_path}" v-for="(item,i) in mp3list" :key="i" @click="changeMedia(item,i)">{{item.name}}</div>
      </div>
      
      <div class="vr" v-if="dataInfo.vr_list.length>0">
        <span class="vr-title">VR全景</span>
        <div class="vr-cover" v-for="item in dataInfo.vr_list" @click="vrClick(item)">
          <van-image :src="showpath+detailOne.imgList[0]" fit="cover"></van-image>
        </div>
      </div>
      <div class="vr" v-if="dataInfo.mp4_list.length>0">
        <span class="vr-title">视频</span>
        <div class="vr-cover" v-for="item in dataInfo.mp4_list" @click="menuClick(item)">
          <van-image :src="showpath+item.cover_img" fit="cover"></van-image>
          <div class="video-icon">
            <span class="iconfont icon-play-mini-fill"></span>
          </div>
        </div>
      </div>

    </div>
    <div class="manager" v-if="config.hudong">
        <template v-if="showClock">
          <div class="manager-item clock" @click="changeclock" v-if="!clocked">打卡</div>
          <div class="manager-item clock disabled" v-else >已打卡</div>
        </template>
        <template v-else>
          <div class="showclock"></div>
        </template>
        <div class="manager-item like"  @click="changelike">
          <!-- <span class="liked iconfont icon-heart-fill" v-if="liked"></span>
          <span class="iconfont icon-heart-line" v-else ></span> -->
          <!-- <span class="liked iconfont icon-appreciatefill" v-if="liked"></span>
          <span class="iconfont ico icon-appreciatefill" v-else ></span> -->
          <span class="liked  iconfont icon-appreciatefill" v-if="liked"></span>
          <span class="iconfont icon-appreciate" v-else ></span>
          <span class="num">{{detailOne.look_count}}</span>
        </div>
        <div class="manager-item share" @click="sharepage">
          <!-- <span class="iconfont icon-share-box-line"></span> -->
          <span class="iconfont icon-ShareIt"></span>
        </div>
      </div>
  </div>
</template>

<script>
import config from "@/config"
import { mapState,mapGetters,mapMutations } from 'vuex';
import FoldTxt2 from '../FoldTxt2.vue'
import SAudioprogress from './s-audioprogress.vue'
import SFeature from '@/components/s-feature.vue'
export default {
  props: {id:Number|String, },
  components:{SAudioprogress,  FoldTxt2,SFeature},
  data(){
    return{
        config,
       liked:false,
        current: 0,
        showpath: null,
        detailOne: null,
        clocked: false,
        playInfo:null,
        maxTxt:"40rem",
        showFeature: false,
        dataInfo: {},
        showClock: true,
    }
  },
  watch: {
      id: {
        handler: function(newv,oldv){
          if(!newv) return;
          if (newv) {
            let that = this;
            that.getSpotById(newv);
          }
        },
        immediate: true
    }
  },
  computed:{
     ...mapGetters("audio", {
      curPlay: "getCurAudio",
    }),
  },
methods:{
  ...mapMutations(['audio/updatePlayInfo','audio/updatePlayState']),
  changelike(){
    this.liked = !this.liked
    if(this.liked) {
      this.detailOne.look_count=this.detailOne.look_count+1;
      this.saveAdd();
    }else {
      this.detailOne.look_count>0&&(this.detailOne.look_count=this.detailOne.look_count-1)
      this.delAdd();
    }
  },
  changeclock(){
    if(!this.clocked){
      this.saveClock();
    }else {
      this.$toast("已经打过卡了")
    } 
  },
  onChange(index){
    this.current = index;
  },
  menuClick(e){
    let obj={
      name:e.name,
      media_path:this.showpath+e.media_path,
      introduce:""
    }
    this.$emit('change',obj)
  },
  vrClick(e){
    let src = e.media_path;
    this.$emit('openvr',src);
  },
  // 获取数据
  async getSpotById(id){
    let data = await this.$api.mapApi.getSpotById(id);
    let res = data.data;
    if(!this.showpath) this.showpath = data.showpath;
    let musicInfo=Object.assign(res);
    if(data.mp3list.length>0){
      let listIn = this.curPlay? data.mp3list.find(t=>{return t.media_path == this.curPlay.media_path}):null
      musicInfo = listIn?listIn:data.mp3list[0]
    }
    musicInfo.src = !musicInfo.media_path?"": musicInfo.media_path.indexOf("http:")!=-1?musicInfo.media_path:this.showpath +musicInfo.media_path 

    try{
      if(config.showMusic){
        musicInfo && musicInfo.media_path && this['audio/updatePlayInfo'](musicInfo)
        musicInfo && musicInfo.media_path && this['audio/updatePlayState'](true)
        this.playInfo = musicInfo.media_path?musicInfo:res.media_path?res:null;
      }
    }catch(err){}

    this.mp3list = data.mp3list;
    res.imgList = res.pic_list&&res.pic_list.split(',');
    res.tags = res.keywords&&res.keywords.split(/,|、|\s/);
    res.dura_tion = this.$utils.map.formData(res.duration);
    this.detailOne = res;
    this.scenic_id = res.id;
    this.dataInfo = data;
    if(data.islike==0){
      this.liked = false;
    }else {
      this.liked = true;
    }
    if(data.isclock==0){
      this.clocked = false;
    }else {
      this.clocked = true;
    }
  },
  // 点赞
  async saveAdd(){
    let scenic_id = this.scenic_id;
    let data = await this.$api.mapApi.addLike(scenic_id);
    // this.$toast.success("点击喜欢成功")
    this.$parent.$parent.updateTimestat = new Date().getTime()+123;
  },
  // 取消点赞
  async delAdd(){
    let scenic_id = this.scenic_id;
    let data = await this.$api.mapApi.deleteLike(scenic_id);
    // this.$toast.success("取消喜欢成功")
  },
  // 打卡
  async saveClock(){
    let scenic_id = this.scenic_id;
    await this.$api.clockApi.add({
        scenic_id: scenic_id,
        scenic_name:this.detailOne.name,
        scenic_picture:this.detailOne.cover_img
    });
    this.clocked = true;
    // this.$toast.success("打卡成功")
    this.$parent.$parent.updateTimestat = new Date().getTime()+123;
    this.$parent.$parent.$refs.smallIntro.clockState = true
    this.$emit("clock",scenic_id)
  },
  // 点击分享
  sharepage(){
    let obj = this.detailOne;
    let data={};
    data.sid = obj.id;
    data.title = obj.name;
    data.imgpath = this.showpath+obj.imgList[0];
    this.$emit('share',data);
  },
  // 切换音频
  changeMedia(res,i){
    if(!res) return;
    res.src = this.showpath+res.media_path;
    this.playInfo = res;
    if(i>0){
      this.showClock = false;
    }else{
      this.showClock = true;
    }
    this.$emit('changeMedia',i)
  }
},
}
</script>
<style  lang="scss">
  .s-intro-big{
    background: #fff;
    border-radius: 20rem 20rem 0 0;
    // width: calc(100vw - 15rem * 2);
    max-height: 85vh;
    width: 100%;
    // max-width: 400rem;
    // position: fixed;
    // left: 15rem;
    // top: 50%;
    // transform: translate(0,-50%);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;

    [data-device='pc'] &.fixed{
      position: fixed;
      left: 30rem;
      // top: 150rem;
      max-width: 400rem;
      bottom: 0;
      z-index: 999;
      padding-bottom: 20rem;
      background:#fff url(../../assets/images/bg2.png) center top no-repeat;
      box-shadow: 0 0 10rem rgba(0, 0, 0, 0.4); 
    }
    [data-device='phone'] &{
      left: 0;
      bottom: 0;
      position: absolute;
      z-index: 999;
    }
    


    .close{
      position: absolute;
      width: 28rem;
      height: 28rem;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 20rem;
      right: 10rem;
      top: 10rem;
      z-index: 8;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      // text-shadow: 0 0 2rem rgba(0, 0, 0, 0.4);
      .iconfont{
        font-size: 20rem;
        color: #fff;
      }
    }
    .intro-pics{
      height: calc(220rem + 15rem);
      background-color: #000;
      // background: var(--mainColor);
      .van-swipe{
        width: 100%;
      }
      .bg{
        filter:blur(10px);
        position: absolute;

      }
      
    }

  }
  .intro-detail{
    border-radius: 5rem;
    position: relative;
    margin-top: -15rem;
    // max-height: 36vh;
    max-height: 40vh;
    overflow-y: scroll;    
    overflow-x: hidden;
    box-sizing: border-box;
    padding: 15rem;
    background:#fff url(../../assets/images/bg2.png) center top no-repeat;
    // background: linear-gradient(180deg, #A9F1DF 0%, #ffffff 40%);
    background-size: 105%;
    .title{
      font-size: 16rem;
      color:#333;
      font-weight: bold;
    }
    .cate{
      margin-top: 10rem;
      display: flex;
      align-items: center;
      .cate-item{
        font-size: 12rem;
        color: var(--mainColor);
        border: 1px solid var(--mainColor);
        border-radius: 5rem;
        margin-right: 5rem;
        height: 20rem;
        padding: 0 5rem;
        display: flex;
        align-items: center;
      }
    }
    .audio-progress{
      margin-top: 15rem;
      color: #414040;
    }
    .brief{
      margin-top: 17rem;
      font-size: 12rem;
      line-height: 1.8;
      // max-height: calc(20rem * 5);
      // height: calc(20rem * 5);
      // overflow: hidden;
      // overflow-y: auto;
      .btn{
        color:var(--mainColor);
      }
    }
    .vr{
      margin-top: 27rem;
      .vr-title{
        font-size: 14rem;
        color: #000;
        font-weight: bolder;
      }
      .vr-cover{
        width: 100%;
        height: 120rem;
        border-radius: 10rem;
        margin-top: 10rem;
        overflow: hidden;
        position: relative;
        .video-icon {
            width: 40rem;
            height: 40rem;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 100%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            z-index: 4;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-size: 20rem;
              color: #fff;
              margin-left: 3rem;
              margin-top: 2rem;
          }
        }
      }
    }
  }

  .manager{
    display: flex;
    align-items: center;
    padding: 19rem 15rem;
    
  }
  .van-swipe{
    width: 100%;
    height: 100%;
  }
  .custom-indicator {
    position: absolute;
    right: 5rem;
    bottom: 20rem;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 20rem;
    padding: 0 10rem;
    height: 22rem;
    line-height: 22rem;
  }
  .intro-detail .ne-range_track,.intro-detail input.ne-range[type="range"]{
    border: 1px solid #f5f5f5;
  }
  .ico-share {
    background: center center no-repeat;
    background-size: contain;
    display: inline-block;
    width: 22rem;
    height: 22rem;
  }
  .showclock {
    width: 110rem;
  }

</style>